/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {ExcelExport, ExcelExportColumn} from '@progress/kendo-react-excel-export'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import FromToPicker from '../BaseComponent/FromToPicker'
import Select from 'react-select'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {min} from 'moment'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'
import {Alert} from 'mdbreact'
import {T} from 'antd/lib/upload/utils'
import AutoComplete from '../BaseComponent/autocomplete'
class DeliveryStatusReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      printInfo: [],
      modalDelete: false,
      pageNumber: 1,
      pageSize: 100,
      sortBy: 'statusId_asc,id_asc',
      processId: null,
      pageNumberDetail: 1,
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'تاریخ دستی',
          value: 'initialDate',
          sorted: false,
          direction: null,
          sortable: true,
          show: true
        },
        {
          name: 'خانواده فرایند',
          value: 'familyStatusChangesTitle',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'نام ویزیتور',
          value: 'visitorName',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'کاربر',
          value: 'userFullName',
          sorted: false,
          direction: null,
          sortable: true,
          show: true
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'کد مشتری',
          value: 'userCode',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'تامین کننده',
          value: 'providerId',
          sorted: false,
          direction: null,
          sortable: true,
          show: true
        },
        {
          name: 'موقعیت',
          value: 'locationTitle',
          sorted: true,
          direction: null,
          sortable: true,
          show: true
        },
        {
          name: 'وضعیت',
          value: 'statusId',
          sorted: false,
          direction: null,
          sortable: true,
          show: true
        },
        {
          name: 'توضیحات',
          value: 'description',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'ویرایش',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        },
        {
          name: 'تاریخچه تغییرات',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false,
          show: true
        }
      ],
      list: [],
      providers: [],
      providerId: '',
      fromDate: '',
      toDate: '',
      locations: [],
      statuses: [],
      histories: [],
      modalDetails: false,
      visitorName: '',
      visitorPhone: '',
      locationId: '',
      statusId: '',
      description: '',
      operatorId: '',
      operators: [],
      changedTimeStampMin: '',
      changedTimeStampMax: '',
      initialDateMin: '',
      initialDateMax: '',
      families: [],
      familyStatusChangesId: null,
      dynamicFilter: null,
      processCategories: [],
      processCategoryId: null,
      newProcess: null,
      userId: null,
      users: []
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.export = exportStatus

    let invoiceFilter = ''
    if (this.state.dynamicFilter && this.state.dynamicFilter.invoiceIdVisibility) {
      invoiceFilter = document.getElementById('invoiceId').value.trim()
    }

    let locationIdFilter = ''
    if (this.state.dynamicFilter !== null && this.state.dynamicFilter.selectiveItemLabelVisibility) {
      locationIdFilter = document.getElementById('locationIdFilter').value.trim()
    }
    let mobileFilter = ''
    if (this.state.dynamicFilter !== null && this.state.dynamicFilter.phoneLabelVisibility) {
      mobileFilter = document.getElementById('mobileFilter').value.trim()
    } else {
      mobileFilter = ''
    }

    let deliveryStatusFilter = document.getElementById('deliveryStatusFilter').value.trim()
    let visitorNameFilter = ''
    if (this.state.dynamicFilter !== null && this.state.dynamicFilter.textLabelVisibility) {
      visitorNameFilter = document.getElementById('visitorNameFilter').value.trim()
    } else {
      visitorNameFilter = ''
    }
    let descriptionFilter = ''
    if (this.state.dynamicFilter !== null && this.state.dynamicFilter.commentLabelVisibility) {
      descriptionFilter = document.getElementById('descriptionFilter').value.trim()
    } else {
      descriptionFilter = ''
    }

    let providerId = ''
    if (this.state.dynamicFilter !== null && this.state.dynamicFilter.providerVisibility) {
      providerId = this.state.providerId == null || this.state.providerId === '' ? '' : this.state.providerId.providerId
    } else {
      providerId = ''
    }

    let changedTimeStampMin = this.state.changedTimeStampMin
    let changedTimeStampMax = this.state.changedTimeStampMax
    let initialDateMin = this.state.initialDateMin
    let initialDateMax = this.state.initialDateMax
    let operatorId =
      this.state.operatorId === null || this.state.operatorId === '' ? '' : this.state.operatorId.personId
    let userId = this.state.userId === null || this.state.userId === '' ? '' : this.state.userId.personId
    let familyStatusChangesId = this.state.familyStatusChangesId === null ? '' : this.state.familyStatusChangesId.id
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (this.state.dynamicFilter.dateLabelVisibility) {
      if (minDate !== '') {
        filter.initialDateMin = minDate
      }
      if (maxDate !== '') {
        filter.initialDateMax = maxDate
      }
    }

    if (changedTimeStampMin !== '') {
      filter.changedTimeStampMin = changedTimeStampMin
    }
    if (changedTimeStampMax !== '') {
      filter.changedTimeStampMax = changedTimeStampMax
    }

    if (initialDateMin) {
      filter.initialDateMin = initialDateMin
    }
    if (initialDateMax) {
      filter.initialDateMax = initialDateMax
    }
    if (operatorId !== '') {
      filter.operatorId = operatorId
    }
    if (userId !== '') {
      filter.userId = userId
    }
    if (locationIdFilter !== '') {
      filter.locationId = locationIdFilter
    }
    if (deliveryStatusFilter !== '') {
      filter.statusId = deliveryStatusFilter
    }
    if (visitorNameFilter !== '') {
      filter.visitorName = visitorNameFilter
    }
    if (mobileFilter !== '') {
      filter.visitorPhone = mobileFilter
    }
    if (descriptionFilter !== '') {
      filter.description = descriptionFilter
    }
    if (this.state.providerId) {
      filter.providerId = this.state.providerId
    }
    if (familyStatusChangesId !== '') {
      filter.processId = familyStatusChangesId
    }
    if (invoiceFilter !== '') {
      filter.invoiceId = invoiceFilter
    }
    return filter
  }

  changeColumnReportTable = (familyStatusChangesId) => {
    let selectedFamily = familyStatusChangesId
    let {sortData} = this.state

    let findDate = sortData.find((item) => item.value === 'initialDate')
    if (findDate) {
      findDate.name = selectedFamily.dateLabel
      findDate.show = selectedFamily.dateLabelVisibility
    }

    let findVisitorName = sortData.find((item) => item.value === 'visitorName')
    if (findVisitorName) {
      findVisitorName.name = selectedFamily.textLabel
      findVisitorName.show = selectedFamily.textLabelVisibility
    }

    let findUser = sortData.find((item) => item.value === 'userFullName')
    if (findUser) {
      findUser.name = selectedFamily.userLabel
      findUser.show = selectedFamily.userLabelVisibility
    }

    let findInvoiceId = sortData.find((item) => item.value === 'invoiceId')
    if (findInvoiceId) {
      findInvoiceId.name = 'شناسه فاکتور'
      findInvoiceId.show = selectedFamily.invoiceIdVisibility
    }

    let findUserCode = sortData.find((item) => item.value === 'userCode')
    if (findUserCode) {
      findUserCode.name = 'کد مشتری'
      findUserCode.show = selectedFamily.userCodeVisibility
    }

    let findProvider = sortData.find((item) => item.value === 'providerId')
    if (findProvider) {
      findProvider.name = 'تامین کننده'
      findProvider.show = selectedFamily.providerVisibility
    }

    let findComment = sortData.find((item) => item.value === 'description')
    if (findComment) {
      findComment.name = selectedFamily.commentLabel
      findComment.show = selectedFamily.commentLabelVisibility
    }

    let findLocation = sortData.find((item) => item.value === 'locationTitle')
    if (findLocation) {
      findLocation.name = selectedFamily.selectiveItemLabel
      findLocation.show = selectedFamily.selectiveItemLabelVisibility
    }
    this.setState(
      {
        sortData,
        newProcess: selectedFamily
      },
      () => {
        console.log(this.state.sortData)
      }
    )
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`deliveryStatus/report`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.changeColumnReportTable(this.state.familyStatusChangesId)
          if (!exportStatus) {
            this.setState({
              list: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            loading: false,
            list: []
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    this.getProviders()
    // this.getLocations()
    // this.getStatus()
    this.getOperator()
    this.getProcessCategory()
    this.getUsers()
    // this.getReport(false)
  }

  getProcessCategory = () => {
    return http
      .get(`process-category/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          res.data.object.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            processCategories: res.data.object
          })
        }
      })
      .catch(() => {})
  }

  changeProcessCategory = (processCategoryId) => {
    if (processCategoryId === null) {
      this.setState({
        processCategoryId: null,
        familyStatusChangesId: null,
        families: []
      })
    } else {
      this.setState({
        processCategoryId
      })
      this.getFamilyChanges(processCategoryId.id)
    }
  }

  getFamilyChanges = (processCategoryId) => {
    return http
      .get(`process/report/operator`, {
        params: {
          processCategoryId,
          export: true
        }
      })
      .then((res) => {
        if (res.data.error === null) {
          let families = res.data.object.result
          families.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            families
          })
        } else {
          this.setState({
            families: []
          })
        }
      })
      .catch((err) => {})
  }

  getOperator = () => {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].personId
            result[i]['label'] = '' + result[i].personId + ' - ' + result[i].name
          }

          this.setState({
            operators: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getProviders = () => {
    // return http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {
    //     params: {
    //         all: true
    //     }
    // }).then((response) => {
    //     if (response.data.error == null) {
    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] ='' + result[i].providerId + ' - ' + result[i].title;
    //         }
    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }
  getLocations = (processId) => {
    return http
      .get(`deliveryStatus/location/report`, {
        params: {
          processId: processId || '',
          export: true
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            locations: response.data.object.result
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  getStatus = (processId) => {
    return http
      .get(`deliveryStatus/status/report`, {
        params: {
          processId: processId || '',
          export: true
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            statuses: response.data.object.result
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getUsers = () => {
    http
      .get(`user/manage/list/user`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].personId
            result[i]['label'] = '' + result[i].personId + ' - ' + result[i].name
          }

          this.setState({
            users: response.data.object
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    let familyStatusChangesId = this.state.familyStatusChangesId === null ? '' : this.state.familyStatusChangesId.id
    if (familyStatusChangesId === '') {
      message.error('خانواده فرایند انتخاب شود.')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  handleChange = (providerId) => {
    this.setState({providerId})
    // alert(JSON.stringify(selectedOption))
  }
  handleChangeOperator = (operatorId) => {
    this.setState({operatorId})
    // alert(JSON.stringify(selectedOption))
  }

  changeUser = (userId) => {
    this.setState({
      userId
    })
  }

  ChangeTimeStampMinDate = (changedTimeStampMin) => {
    this.setState({
      changedTimeStampMin
    })
  }

  ChangeInitMinDate = (initialDateMin) => {
    this.setState({
      initialDateMin
    })
  }
  ChangeInitMaxDate = (initialDateMax) => {
    this.setState({
      initialDateMax
    })
  }

  ChangeTimeStampMaxDate = (changedTimeStampMax) => {
    this.setState({
      changedTimeStampMax
    })
  }

  showDetails = (id, pageNumberDetail) => {
    this.setState(
      {
        masterId: id,
        pageNumberDetail
      },
      () => {
        const model = {
          masterId: id,
          sortBy: 'changedTimeStamp_desc',
          pageNumber: pageNumberDetail,
          pageSize: 10
        }
        http
          .get(`deliveryStatus/detail`, {
            params: model
          })
          .then((response) => {
            if (response.data.error === null) {
              this.setState(
                {
                  histories: response.data.object.result,
                  countAllDetails: response.data.object.countAll
                },
                () => {
                  if (this.state.histories.length) {
                    this.setState({
                      modalDetails: true
                    })
                  } else {
                    message.error('هیچ تاریخچه ای وجود ندارد')
                  }
                }
              )
            }
          })
          .catch((error) => {
            alert(JSON.stringify(error))
          })
      }
    )
  }

  changePageDetails = (pageNumberDetail) => {
    this.setState(
      {
        pageNumberDetail
      },
      () => {
        this.showDetails(this.state.masterId, pageNumberDetail)
      }
    )
  }

  showEdit = (visitorName, visitorPhone, locationId, statusId, description, id) => {
    this.setState({
      visitorName,
      visitorPhone,
      locationId,
      statusId,
      description,
      deliveryId: id,
      editModal: true
    })
  }

  changeFields = (e) => {
    let value = e.target.value
    let name = e.target.name
    this.setState({
      [name]: value
    })
  }
  editOk = () => {
    let {visitorName, visitorPhone, locationId, statusId, description, deliveryId} = this.state
    if (visitorName === '' || locationId === '' || statusId === '') {
      message.error('فیلد های ستاره دار وارد شود ')
    } else if (!(visitorPhone == '') && !visitorPhone.match(/^09\d{9}$/g)) {
      message.error('موبایل معتبر نیست')
    } else {
      let data = {
        id: deliveryId,
        visitorName,
        visitorPhone,
        locationId,
        statusId,
        description
      }
      http.put(`deliveryStatus/${deliveryId}/update`, data, {}).then((res) => {
        if (res.data.error === null) {
          message.success('با موفقیت ویرایش شد')
          this.setState(
            {
              editModal: false
            },
            () => {
              this.getReport(false)
            }
          )
        } else {
          message.error(res.data.description)
        }
      })
    }
  }

  showFullDescription = (description) => {
    this.setState({
      description,
      modalDescription: true
    })
  }

  changeFamily = (familyStatusChangesId) => {
    this.setState(
      {
        userId: null,
        familyStatusChangesId,

        dynamicFilter: familyStatusChangesId
      },
      () => {
        if (familyStatusChangesId === null) {
          this.getLocations()
          this.getStatus()
        } else {
          this.getLocations(familyStatusChangesId.id)
          this.getStatus(familyStatusChangesId.id)
        }
      }
    )
  }

  openConfirmation = (id) => {
    this.setState(
      {
        processId: id,
        confirmation: true
      },
      () => {
        if (this.state.confirmation) {
          setTimeout(() => {
            document.getElementById('noBtn').focus()
          }, 1000)
        }
      }
    )
  }

  GoToEdit = () => {
    let {processId} = this.state
    this.setState({
      confirmation: false
    })
    window.open(`/deliveryStatus/edit/${processId}`, '_blank')
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`deliveryStatus/report`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['initialDate'] = excelReport[i]['initialDate']
              ? jMoment(excelReport[i]['initialDate']).format('jYY/jMM/jDD HH:mm')
              : ''
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  render() {
    let {pageNumber, pageSize, loading, newProcess} = this.state

    let printCol = ['ردیف', 'تاریخ', 'نام ویزیتور', 'موبایل ویزیتور', 'تامین کننده', 'موقعیت', 'وضعیت', 'توضیحات']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="فرایندها"
              headerColSpan={8}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={2}
              centerColSpan={3}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>
                    <span>{jMoment(item.initialTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</span>
                  </td>
                  <td>{item.visitorName}</td>
                  <td>{item.visitorPhone}</td>
                  <td>{item.providerName}</td>
                  <td>{item.locationTitle}</td>
                  <td>{item.statusTitle}</td>
                  <td>{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="مدیریت فرایندها.xls"
          >
            {newProcess && newProcess.dateLabelVisibility && (
              <ExcelExportColumn
                key={'initialDate'}
                field={'initialDate'}
                title={newProcess.dateLabel}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            <ExcelExportColumn
              key={'processTitle'}
              field={'processTitle'}
              title={'خانواده فرایند'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            {newProcess && newProcess.textLabelVisibility && (
              <ExcelExportColumn
                key={'visitorName'}
                field={'visitorName'}
                title={newProcess.textLabel}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            {newProcess && newProcess.userLabelVisibility && (
              <ExcelExportColumn
                key={'userFullName'}
                field={'userFullName'}
                title={newProcess.userLabel}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            {newProcess && newProcess.invoiceIdVisibility && (
              <ExcelExportColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            ‍
            {newProcess && newProcess.userCodeVisibility && (
              <ExcelExportColumn
                key={'userCode'}
                field={'userCode'}
                title={'کد مشتری'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            ‍
            {newProcess && newProcess.providerVisibility && (
              <ExcelExportColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            ‍
            {newProcess && newProcess.selectiveItemLabelVisibility && (
              <ExcelExportColumn
                key={'locationTitle'}
                field={'locationTitle'}
                title={newProcess.selectiveItemLabel}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
            <ExcelExportColumn
              key={'statusTitle'}
              field={'statusTitle'}
              title={'وضعیت'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            ‍
            {newProcess && newProcess.commentLabelVisibility && (
              <ExcelExportColumn
                key={'description'}
                field={'description'}
                title={newProcess.commentLabel}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            )}
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>مدیریت فرایندها</li>
            <li>گزارش</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid
                  getPageSize={this.getPageSize}
                  createLink={'/deliveryStatus/add'}
                  enablePageSize
                  defaultSize="100"
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                {/* <button className='printButton' onClick={this.exportPrint}>
                                    <i className='fas fa-print'></i>
                                </button> */}
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>
                    دسته فرایند :<span className="text-danger">*</span>
                  </label>
                  <Select
                    value={this.state.processCategoryId}
                    onChange={this.changeProcessCategory}
                    options={this.state.processCategories}
                    isClearable={true}
                    placeholder={''}
                  />
                </div>
                <div className="formComponent">
                  <label>
                    خانواده فرایند :<span className="text-danger">*</span>
                  </label>
                  <Select
                    value={this.state.familyStatusChangesId}
                    onChange={this.changeFamily}
                    options={this.state.families}
                    isClearable={true}
                    placeholder={''}
                  />
                </div>
                {this.state.dynamicFilter !== null && this.state.dynamicFilter.dateLabelVisibility && (
                  <FromToPicker
                    onChangeFromDate={this.handleChangeFromDate}
                    onChangeToDate={this.handleChangeToDate}
                    fromLabel={this.state.dynamicFilter.dateLabel + ' از '}
                    toLabel={this.state.dynamicFilter.dateLabel + ' تا '}
                    fromId="from"
                    toId="to"
                  />
                )}

                <FromToPicker
                  onChangeFromDate={this.ChangeInitMinDate}
                  onChangeToDate={this.ChangeInitMaxDate}
                  fromLabel="تاریخ ثبت اولیه از"
                  toLabel="تاریخ ثبت اولیه تا"
                  fromId="fromReg"
                  toId="toReg"
                  lastMonth
                />

                <FromToPicker
                  onChangeFromDate={this.ChangeTimeStampMinDate}
                  onChangeToDate={this.ChangeTimeStampMaxDate}
                  fromLabel="تاریخ آخرین تغییر از"
                  toLabel="تاریخ آخرین تغییر تا"
                  fromId="fromEdit"
                  toId="toEdit"
                />
                {this.state.dynamicFilter !== null && this.state.dynamicFilter.providerVisibility && (
                  <div className="formComponent selectComponent">
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      value={this.state.providerId}
                      setValue={(providerId) => this.setState({providerId})}
                    />
                    {/* <label>تامین کننده :</label>
                                    <Select
                                        value={this.state.providerId}
                                        onChange={this.handleChange}
                                        options={this.state.providers}
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder={''}
                                        id="providerFilter"
                                        name="providerFilter"
                                        tabIndex='1'
                                    /> */}
                  </div>
                )}

                <div className="formComponent">
                  <label>اپراتور ثبت کننده :</label>
                  <Select
                    value={this.state.operatorId}
                    onChange={this.handleChangeOperator}
                    options={this.state.operators}
                    isClearable={true}
                    placeholder={''}
                  />
                </div>
                {this.state.dynamicFilter !== null && this.state.dynamicFilter.userLabelVisibility && (
                  <div className="formComponent">
                    <label>{this.state.dynamicFilter.userLabel}</label>
                    <Select
                      value={this.state.userId}
                      onChange={this.changeUser}
                      options={this.state.users}
                      isClearable={true}
                      placeholder={''}
                    />
                  </div>
                )}

                {this.state.dynamicFilter !== null && this.state.dynamicFilter.invoiceIdVisibility && (
                  <div className="formComponent">
                    <label>شناسه فاکتور</label>
                    <input className="form-control" id="invoiceId" />
                  </div>
                )}

                {this.state.dynamicFilter !== null && this.state.dynamicFilter.selectiveItemLabelVisibility && (
                  <div className="formComponent">
                    <label>{this.state.dynamicFilter.selectiveItemLabel}</label>
                    <select className="form-control" id="locationIdFilter" name="deliveryLocationFilter">
                      <option value={''}>-------</option>

                      {this.state.locations.map((loc, index) => (
                        <option key={index} value={loc.id}>
                          {loc.title}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="formComponent">
                  <label>وضعیت</label>
                  <select className={'form-control'} name="statusFilter" id="deliveryStatusFilter">
                    <option value="">-------</option>
                    {this.state.statuses.map((orderStatus, index) => (
                      <option key={index} value={orderStatus.id}>
                        {orderStatus.title}
                      </option>
                    ))}
                  </select>
                </div>
                {this.state.dynamicFilter !== null && this.state.dynamicFilter.textLabelVisibility && (
                  <div className="formComponent">
                    <label>{this.state.dynamicFilter.textLabel}</label>
                    <input className="form-control" id="visitorNameFilter" type="text" />
                  </div>
                )}
                {this.state.dynamicFilter !== null && this.state.dynamicFilter.phoneLabelVisibility && (
                  <div className="formComponent">
                    <label>{this.state.dynamicFilter.phoneLabel}</label>
                    <input className="form-control" id="mobileFilter" type="number" />
                  </div>
                )}
                {this.state.dynamicFilter !== null && this.state.dynamicFilter.commentLabelVisibility && (
                  <div className="formComponent">
                    <label>توضیحات</label>
                    <input className="form-control" id="descriptionFilter" type="text" />
                  </div>
                )}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            {this.state.list.length > 0 && (
              <div className="showBaseTable">
                <table className="baseTable">
                  <Sort data={this.state.sortData.filter((i) => i.show)} getSort={this.getSort} />
                  <tbody>
                    {this.state.list.map((item, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * pageSize + index + 1}</td>

                        {newProcess.dateLabelVisibility && (
                          <td>
                            <span>
                              {item.initialDate !== null && jMoment(item.initialDate).format('jYYYY/jMM/jDD')}
                            </span>
                          </td>
                        )}
                        <td>{item.processTitle}</td>
                        {newProcess.textLabelVisibility && <td>{item.visitorName}</td>}
                        {newProcess.userLabelVisibility && <td>{item.userFullName}</td>}
                        {newProcess.invoiceIdVisibility && <td>{item.invoiceId}</td>}
                        {newProcess.userCodeVisibility && <td>{item.userCode}</td>}

                        {newProcess.providerVisibility && (
                          <td>{item.providerId !== null && item.providerId + ' - ' + item.providerName}</td>
                        )}

                        {newProcess.selectiveItemLabelVisibility && <td>{item.locationTitle}</td>}

                        <td style={{background: item.statusColor}} className="text-white font-weight-bold">
                          {item.statusTitle}
                        </td>
                        {newProcess.commentLabelVisibility && (
                          <td>
                            <span
                              style={{cursor: 'pointer'}}
                              onClick={() => this.showFullDescription(item.description)}
                            >
                              {item.description !== null && item.description.length > 20
                                ? item.description.substr(0, 19) + '...'
                                : item.description}
                            </span>
                          </td>
                        )}

                        <td>
                          {item.statusProcessLevelId === 3 ? (
                            <button className="bg-transparent border-0" onClick={() => this.openConfirmation(item.id)}>
                              <img src={require('../../image/editDriver.svg')} alt="" />
                            </button>
                          ) : (
                            <Link target="_blank" to={`/deliveryStatus/edit/${item.id}`}>
                              <img src={require('../../image/editDriver.svg')} alt="" />
                            </Link>
                          )}
                        </td>
                        <td>
                          <button className="details" onClick={() => this.showDetails(item.id, 1)}>
                            <img src={require('../../image/details.svg')} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumber}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.pageNumber}
                    total={this.state.countAll}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        <Modal size="sm" isOpen={this.state.confirmation} toggle={() => this.setState({confirmation: false})}>
          <ModalBody>این فرایند در وضعیت پایانی قرار دارد.آیا از ویرایش مجدد آن اطمینان دارید؟؟</ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" id="noBtn" onClick={() => this.setState({confirmation: false})}>
              خیر
            </button>{' '}
            <button className="confirmBtnModal" onClick={() => this.GoToEdit()}>
              بله
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.editModal} toggle={() => console.log('')} size="lg">
          <ModalHeader toggle={() => this.setState({editModal: false})}>ویرایش وضعیت تغییر</ModalHeader>
          <ModalBody>
            <form className="modalForm editWareForm editOrderModalForm">
              <figure>
                <label>
                  وضعیت :<span className="text-danger mx-2">*</span>
                </label>
                <select className={'form-control'} onChange={this.changeFields} name="statusId" id="statusId">
                  <option value="">-------</option>
                  {this.state.statuses.map((orderStatus, index) => (
                    <option
                      key={index}
                      value={orderStatus.id}
                      selected={+orderStatus.id === +this.state.statusId ? true : false}
                    >
                      {orderStatus.title}
                    </option>
                  ))}
                </select>
              </figure>

              <figure id="description">
                <label>توضیحات : </label>
                <textarea
                  style={{fontSize: '0.9em', minWidth: '325px !important'}}
                  className={'form-control'}
                  name="description"
                  id="description"
                  defaultValue={this.state.description}
                  onChange={this.changeFields}
                />
              </figure>

              <figure>
                <label>
                  محل تحویل :<span className="text-danger mx-2">*</span>
                </label>
                <select className="form-control" onChange={this.changeFields} id="locationId" name="locationId">
                  <option value={''}>-------</option>

                  {this.state.locations.map((loc, index) => (
                    <option key={index} selected={+loc.id === +this.state.locationId ? true : false} value={loc.id}>
                      {loc.title}
                    </option>
                  ))}
                </select>
              </figure>

              <figure>
                <label>
                  نام ویزیتور :<span className="text-danger mx-2">*</span>
                </label>
                <input
                  type={'text'}
                  className={'form-control'}
                  name="visitorName"
                  id="visitorName"
                  onChange={this.changeFields}
                  defaultValue={this.state.visitorName}
                />
              </figure>
              <figure>
                <label>شماره همراه ویزیتور : </label>
                <input
                  type={'text'}
                  className={'form-control'}
                  id="visitorPhone"
                  name="visitorPhone"
                  onChange={this.changeFields}
                  defaultValue={this.state.visitorPhone}
                />
              </figure>
            </form>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({editModal: false})}>
              لغو
            </button>{' '}
            <button className="confirmBtnModal" onClick={this.editOk}>
              ویرایش{' '}
            </button>
          </ModalFooter>
        </Modal>
        <Modal className="bigModal" isOpen={this.state.modalDetails} size="lg">
          <ModalHeader toggle={() => this.setState({modalDetails: false})}>لیست تغییرات اعمال شده</ModalHeader>
          <ModalBody>
            <div>
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>وضعیت</td>
                    <td>کاربر</td>
                    <td>تاریخ تغییر</td>
                    <td>توضیحات</td>
                  </tr>
                  {this.state.histories.map((change, index) => (
                    <tr key={index + 'det'}>
                      <td>{index + 1}</td>
                      <td>{change.statusTitle}</td>
                      <td>{change.operatorFirstName + ' ' + change.operatorLastName}</td>
                      <td>{jMoment(change.changedTimeStamp).format('jYYYY/jMM/jDD HH:mm')}</td>
                      <td>{change.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.changePageDetails}
                  pageSize={10}
                  currentPage={this.state.pageNumberDetail}
                  total={this.state.countAllDetails}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modalDetails: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalDescription} toggle={() => this.setState({modalDescription: false})}>
          <ModalBody>
            <div>
              <h5 className="font-weight-bold">توضیحات :‌ </h5>
              <h6>{this.state.description}</h6>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modalDescription: false})}>
              بستن
            </button>{' '}
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DeliveryStatusReport
